var app = angular.module('directives.calculator', []);

require('./directives/calculator.directive.js');
require('./templates/calculator.html');
require('./stylesheets/index.scss');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/calculator/index.js
 ** module id = 139
 ** module chunks = 1
 **/